import React, { Component } from "react";

import { readRemoteSession, readWebReturn } from "../../context/RemoteLaunchContext";
import "./SessionEnded.css";

/**
 * WEB-410 — where a web player lands when their visit is over.
 *
 * A standalone web player arrives at /go/<slug>, and their token expires like
 * anybody's. PrivateRoute used to answer that by sending them to /login: the
 * venue staff's screen, asking a patron on their phone for a username and
 * password they have never had. It is a dead end — nothing they can type, and
 * nothing on the page telling them so.
 *
 * This is the whole replacement. One sentence saying the visit is over, and
 * one link starting a new one. No error, no apology, no explanation of session
 * lifetimes: from the player's side nothing went wrong, they came back later
 * than the visit lasted.
 *
 * Deliberately not an automatic redirect. A stale token that bounced straight
 * back to /go/ would loop in silence, which is harder to diagnose and worse to
 * sit through than a page with a button on it.
 *
 * WEB-412 qualifies that, and this screen is what makes the qualification
 * safe. OnsiteGate DOES restart a visit automatically, because a player being
 * asked for their location has just this second walked up, and handing them a
 * "thank you for playing" instead of the game is absurd. It restarts once;
 * a second failure inside a minute arrives here instead. So the loop above is
 * still not possible -- this page is the thing that stops it, rather than the
 * reason nobody tried.
 *
 * Two sources for everything it needs, because they fail in different ways:
 * the live session knows it all but dies with the tab, and the remembered
 * return survives the tab but not a cleared browser. Either one is enough.
 *
 * Two ways out. "Click to restart" opens a new visit at /go/<slug>. "Click to
 * Return" sends them to Venue.web_return_url -- the venue's own page, where a
 * finished player is meant to end up. That one is optional by design: a venue
 * that set no return URL gets no Return link, because a link to nowhere is
 * worse than no link.
 */
class SessionEnded extends Component {
    /** Whatever we still know about where this player came from. */
    origin(){
        let session = readRemoteSession() || {};
        let options = session.displayOptions || {};
        let remembered = readWebReturn() || {};

        return {
            slug: session.webSlug || options.web_slug || remembered.slug || "",
            // Venue.web_return_url. Optional by design -- a venue with none
            // gets no Return link rather than a link to nowhere.
            returnUrl: options.returnUrl
                || options.return_url
                || remembered.returnUrl
                || "",
            name: session.promoName
                || session.venueName
                || options.venue_name
                || remembered.promoName
                || remembered.venueName
                || "",
        };
    }

    render(){
        let { slug, name, returnUrl } = this.origin();

        return (
            <div className="session-ended">
                <div className="session-ended-card">
                    <h1>Thank you for playing{name ? ` ${name}` : ""}</h1>

                    <div className="session-ended-actions">
                        {slug ? (
                            <a className="session-ended-again" href={`/go/${slug}`}>
                                Click to restart
                            </a>
                        ) : (
                            // Nothing remembered -- a cleared browser, or a
                            // private window. A link to nowhere is worse than
                            // no link.
                            <p className="session-ended-note">
                                Open your promotion link again to keep playing.
                            </p>
                        )}

                        {returnUrl ? (
                            <a className="session-ended-return" href={returnUrl}>
                                Click to Return
                            </a>
                        ) : null}
                    </div>

                </div>
            </div>
        );
    }
}

export default SessionEnded;
